import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { InfomedicalSubcuentaPrograma } from '../../models/infomedical-subcuenta-programa/infomedical-subcuenta-programa';

@Injectable({
  providedIn: 'root',
})
export class InfomedicalSubcuentaProgramaService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.INFOMEDICAL_SUBCUENTA_PROGRAMA}`;

  constructor(private http: HttpClient) {}

  getSubcuentasPrograma(
    lineaNegocio: string,
    tipoPlan: string,
  ): Observable<InfomedicalSubcuentaPrograma[]> {
    const body = {
      nombreClave: 'sg_get_infomedical_subcuentaPrograma',
      jsonParametros: JSON.stringify({
        '@linea_negocio': lineaNegocio,
        '@prm_tipo_plan': tipoPlan,
      }),
    };

    return this.http.post<InfomedicalSubcuentaPrograma[]>(this.apiUrl, body);
  }
}
